<template>
  <div
    class="instruction-overlay"
    :class="{ 'mobile-instructions': isMobile }"
  >
    <div
      v-if="isDetecting && !faceDetected"
      class="instruction-text"
    >
      Posicione seu rosto dentro da moldura oval
    </div>
    <div
      v-if="faceDetected && faceInsideOval"
      class="face-detected-text"
    >
      ✓ Rosto posicionado corretamente!
    </div>
    <div
      v-if="faceDetected && !faceInsideOval"
      class="face-outside-text"
    >
      Posicione seu rosto no centro do oval
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaceDetectionOverlay',
  props: {
    isDetecting: {
      type: Boolean,
      default: false,
    },
    faceDetected: {
      type: Boolean,
      default: false,
    },
    faceInsideOval: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.instruction-overlay {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  text-align: center;
  width: 90%;
  max-width: 400px;
  pointer-events: none;
}

.instruction-text {
  font-size: 1.2rem;
  color: #2196f3;
  background: rgba(255, 255, 255, 0.95);
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 2px solid #2196f3;
  margin-bottom: 10px;
  display: inline-block;
}

.face-detected-text {
  font-size: 1.2rem;
  color: #ffffff;
  background: #28a745;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 2px solid #28a745;
  animation: pulse-green 1.5s infinite;
  margin-bottom: 10px;
  display: inline-block;
}

.face-outside-text {
  font-size: 1.2rem;
  color: #ffffff;
  background: #FF6B00;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 2px solid #FF6B00;
  animation: pulse-orange 1.5s infinite;
  margin-bottom: 10px;
  display: inline-block;
}

.mobile-instructions {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 15;
  text-align: center;
  width: 95%;
  max-width: 350px;
}

.mobile-instructions .instruction-text,
.mobile-instructions .face-detected-text,
.mobile-instructions .face-outside-text {
  font-size: 1.1rem;
  padding: 10px 15px;
  margin-bottom: 8px;
}

@keyframes pulse-green {
  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7); }
  70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

@keyframes pulse-orange {
  0% { box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.7); }
  70% { box-shadow: 0 0 0 10px rgba(255, 107, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 107, 0, 0); }
}
</style>
